<template>
  <div class="app-content content devcontent ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
            <div class="container-fluid">
                <div class="row breadcrumbs-top">
                  <div class="col-md-12 content-header-left px-0">
                    <h3 class="content-header-title float-left mb-0" > Toute Traking  </h3>
                    
                    <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">routes</a>
                                </li>
                                
                                
                                
                                
                            </ol>
                        </div>
                  </div>
                </div>
            </div>
            
        </div>
      <div class="card content-body" style="border-radius: 16px;">
               <div class="card-header px-0  common_top_title_searchbgst_dock" style="display: none;">
                    <div class="container-fluid " >
                        <div class="row row fc_my-05">
                            <div class="w-auto px-1 mobile-padding-0-2">
                                <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                    <div class="avatar-content">
                                        <em class="las la-route i_icon_st font-medium-5"></em>
                                    </div>
                                </div>
                                
                                <h4 class="card-title d-inline-flex ml-0 mb-0">Live Vehicle Location</h4>
                            </div>
                        </div>    
                            
                    </div>
                </div>
                <section class="p-0  main_route_traking_map" >
                    <div class="container px-0">
                        
                        <div class="map_image_full">
                            <img alt="" src="../../public/images/icons/routemap001.png">
                        </div>
                    </div>
                </section>
          <section class="p-1 main_route_traking_map" style="display: none;">

            <div class="row">
                <div class="col-md-3 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Total Vehicle</p>
                                <h4 class="font-weight-bolder mb-0">10000</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Total Trips Count</p>
                                <h4 class="font-weight-bolder mb-0">100</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Total Distance</p>
                                <h4 class="font-weight-bolder mb-0">2000 km</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Total Time</p>
                                <h4 class="font-weight-bolder mb-0">04:00 hr</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Total Idle Time</p>
                                <h4 class="font-weight-bolder mb-0">03:00 hr</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Total Incidents</p>
                                <h4 class="font-weight-bolder mb-0">100</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Total Fuel Consumed</p>
                                <h4 class="font-weight-bolder mb-0">5000 ltr</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Avg. Mileage</p>
                                <h4 class="font-weight-bolder mb-0">15 kmpl</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container px-0">
                <div class="card-header bg-white">
                  <h5 class="card-title"> Vehicle Route Details</h5>
                </div>
                <div class="map_image_full">
                    <img alt="" src="../../public/images/icons/routemap.png">
                </div>
            </div>
            <div class="container px-0 mt-2">
                <div class="route_map_table">
                    <div class="table-responsive datatableview">
                    <table  class="table table-hover table_stickys table-striped table-col-td-white custom_doctable">
                        <thead>
                            <th> Order ID</th>
                            <th> Location</th>
                            <th> Task</th>
                            <th> STA </th>
                            <th> ATA </th>
                            <th> STD </th>
                            <th> ATD </th>
                            <th> Demand</th>
                            <th> 4</th>
                            <th> Status</th>

                        </thead>
                        <tbody>
                            <tr> 
                                <td> 1 </td>
                                <td> Pune </td>
                                <td> Starting Location </td>
                                <td> - </td>
                                <td> - </td>
                                <td> 09:50 </td>
                                <td> 09:05 </td>
                                <td> 0 </td>
                                <td> -00:45 </td>
                                <td> Started </td>
                            </tr>
                            <tr> 
                                <td> 2 </td>
                                <td> Nashik </td>
                                <td> Pickup </td>
                                <td> 09:59 </td>
                                <td> 09:07 </td>
                                <td> 09:50 </td>
                                <td> 09:05 </td>
                                <td> 12 </td>
                                <td> -00:45 </td>
                                <td> Done </td>
                            </tr>
                            <tr> 
                                <td> 3 </td>
                                <td> Satara </td>
                                <td> Pickup </td>
                                <td> 09:59 </td>
                                <td> 09:07 </td>
                                <td> 09:50 </td>
                                <td> 09:05 </td>
                                <td> 8 </td>
                                <td> -00:45 </td>
                                <td> Done </td>
                            </tr>
                            <tr> 
                                <td> 4 </td>
                                <td> Nagpur </td>
                                <td> Pickup </td>
                                <td> 09:59 </td>
                                <td> 09:07 </td>
                                <td> 09:50 </td>
                                <td> 09:05 </td>
                                <td> 5 </td>
                                <td> -00:45 </td>
                                <td> Done </td>
                            </tr>
                            <tr> 
                                <td> 5 </td>
                                <td> Mumbai </td>
                                <td> Pickup </td>
                                <td> 09:59 </td>
                                <td> 09:07 </td>
                                <td> 09:50 </td>
                                <td> 09:05 </td>
                                <td> 4 </td>
                                <td> -00:45 </td>
                                <td> Done </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
                
            </div>
            
          </section>
      </div>
    </div>
  </div>
</template>
<script>
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import VueElementLoading from 'vue-element-loading'
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"
import Treeselect from '@riophae/vue-treeselect'
export default {
  name: "routeTraking",
  mixins: [common_methods, searchMasterNameList],
  data() {
    return {
      map: null,
    };
  },
  components: {
    MarkerClusterer,
    Treeselect,
  },
  mounted() {
    
  },
  methods: {
  
    
  },
};
</script>

<style scoped>


</style>